import { DefaultButton, PrimaryButton } from "@fluentui/react";
import Moment from "moment";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import styles from "../Hospital/hospital.module.css";
import { ACTIONS, AuthRoutes, USERTYPES } from "../../constants/Constants";
import { getEnv } from "../../helpers/EnvHelper";
import { statusStyle } from "../StudyList/helpers/ConstantStyles";
const ColumnsClient = (handleClickGroup, userRole) => {
  const [t, i18n] = useTranslation();
  // const childTrPadding =
  //   getEnv("REACT_APP_HYBRID_MODE") == "false" ? "15px 5px" : "15px 10px";

    const childTrPadding = (getEnv("REACT_APP_HYBRID_MODE") == "false") ? "15px 0px 15px 10px" : "15px 10px";
    const rowTrPadding = "0px 10px";

  const showAction = userRole != USERTYPES.FIRMDOCTOR && userRole != USERTYPES.FIRMTECHNICIAN;
  const detailsW  = showAction ? "23%" : "30%";
  const contactW  = showAction ? "31%" : "40%";
  const typeW     = showAction ? "23%" : "30%";
  const actionW   = "23%";

  return [
    {
      id: "username",
      style: { width: detailsW, boxSizing:'border-box',padding:rowTrPadding },
      headerStyle: { padding: "15px 0px 15px 10px", textAlign: "left", width: detailsW, boxSizing:'border-box' },
      headerClass: "break-word",
      classChildName: "break-word cursor-pointer",
      header: () => <span className="">Details</span>,
      accessor: "clients",
      accessorKey: "clients",
      show: true,
      cell: (cell) => (
        <>
          <div>
            <div className="user-heading">Name</div>
            <div className="user-sub-heading">{cell.row.original.name}</div>
          </div>

          <div className="user-mt-10">
            <div className="user-heading">Address</div>
            <div className="user-sub-heading">{cell.row.original.address}</div>
          </div>
        </>
      ),
    },
    {
      id: "email",
      style: { width: contactW, boxSizing:'border-box',padding:rowTrPadding },
      headerStyle: {
        padding: childTrPadding,
        textAlign: "left",
        width: contactW,
        boxSizing:'border-box'
      },
      headerClass: "break-word",
      classChildName: "break-word cursor-pointer",
      header: () => <span className="">Contact Details</span>,
      accessor: "email",
      accessorKey: "email",
      show: true,
      cell: (cell) => (
        <>
          <div>
            <div className="user-heading">{t("user.email")}</div>
            <div className="user-sub-heading">
              {userRole === USERTYPES.FIRMADMIN || userRole === USERTYPES.RADIOLOGIST || userRole === USERTYPES.FIRMDOCTOR || userRole === USERTYPES.FIRMTECHNICIAN
                ? cell.row.original?.email === ""
                  ? "-"
                  : cell.row.original?.email
                : cell.row.original?.contact1 === null ||
                  cell.row.original?.contact1?.email === ""
                ? "-"
                : cell.row.original?.contact1?.email}
            </div>
          </div>

          <div className="user-mt-10">
            <div className="user-heading">{t("user.mobile")}</div>
            <div className="user-sub-heading">
              {userRole === USERTYPES.FIRMADMIN || userRole === USERTYPES.RADIOLOGIST || userRole === USERTYPES.FIRMDOCTOR || userRole === USERTYPES.FIRMTECHNICIAN
                ? cell.row.original?.mobileNo === ""
                  ? "-"
                  : cell.row.original?.mobileNo
                : cell.row.original?.contact1 === null ||
                  cell.row.original?.contact1?.mobile === ""
                ? "-"
                : cell.row.original?.contact1?.mobile}
            </div>
          </div>
        </>
      ),
    },
    {
      id: "Type",
      style: { width: typeW, boxSizing:'border-box',padding:rowTrPadding },
      headerStyle: {
        padding: childTrPadding,
        textAlign: "left",
        width: typeW,
        boxSizing:'border-box'
      },
      headerClass: "break-word",
      classChildName: "break-word cursor-pointer",
      header: () => <span className="">{userRole === USERTYPES.FIRMDOCTOR || userRole === USERTYPES.FIRMTECHNICIAN ? "Type" : "Status"}</span>,
      accessor: "type",
      accessorKey: "type",
      show: true,
      cell: (cell) => (
        <>
          <div>
            <div className="user-heading">Type</div>
            <div className="user-sub-heading">
              {/* distinguish full firms from minimal accounts. */}
              {cell.row.original.firmType}
              {/* Show the Full Firm/Minimal tag for Super Admin (firm list) AND Firm Admin
                  (client list). */}
              {(userRole === USERTYPES.ADMIN || userRole === USERTYPES.FIRMADMIN) && (
                <>
                  {" | "}
                  {cell.row.original.isMinimalAccount ? "Minimal" : "Full Firm"}
                </>
              )}
            </div>
          </div>

          {userRole != USERTYPES.FIRMDOCTOR && userRole != USERTYPES.FIRMTECHNICIAN && <div className="user-mt-10">
            <div className="user-heading">Connection Status</div>
            <div className="user-sub-heading">
              {((userRole === USERTYPES.FIRMADMIN || userRole === USERTYPES.RADIOLOGIST) &&
                cell.row.original.status !== "Active") ||
              (userRole === USERTYPES.ADMIN &&
                cell.row.original.active === false)
                ? <><span className="inactive-red-dot"></span>{t("hospital.inactive")}</>
                : <><span className="active-green-dot"></span>{t("hospital.active")}</>}
            </div>
          </div>}

           {cell.row.original.demoFirm && (
             <div className="user-mt-10" style={{ display: "flex", gap: "6px", flexWrap: "wrap" }}>
               <div className="study-list-reportDetails-badges">
                 <div
                   className="study-list-report-details-text"
                   style={{
                     ...statusStyle,
                     backgroundColor: "#0078d4",
                     color: "#ffffff",
                   }}
                 >
                   DEMO
                 </div>
               </div>
               {cell.row.original.demoExpiryDate && (
                 <div className="study-list-reportDetails-badges">
                   <div
                     className="study-list-report-details-text"
                     style={{
                       ...statusStyle,
                       backgroundColor: "#d9534f",
                       color: "#ffffff",
                     }}
                   >
                     Expiry Date: {Moment(cell.row.original.demoExpiryDate).format("DD-MMM-YYYY").toLocaleLowerCase()}
                   </div>
                 </div>
               )}
               {cell.row.original.demoStudyCount != null && cell.row.original.maxStudyUploads != null && cell.row.original.maxStudyUploads > 0 && (
                 <div className="study-list-reportDetails-badges">
                   <div
                     className="study-list-report-details-text"
                     style={{
                       ...statusStyle,
                       backgroundColor: "#d9534f",
                       color: "#ffffff",
                     }}
                   >
                     Studies Consumed: {cell.row.original.demoStudyCount} / {cell.row.original.maxStudyUploads}
                   </div>
                 </div>
               )}
             </div>
           )}

           {cell.row.original.firmDemo && (
             <div className="user-mt-10" style={{ display: "flex", gap: "6px", flexWrap: "wrap" }}>
               <div className="study-list-reportDetails-badges">
                 <div
                   className="study-list-report-details-text"
                   style={{
                     ...statusStyle,
                     backgroundColor: "#0078d4",
                     color: "#ffffff",
                   }}
                 >
                   DEMO
                 </div>
               </div>
               {cell.row.original.firmDemoExpiryDate && (
                 <div className="study-list-reportDetails-badges">
                   <div
                     className="study-list-report-details-text"
                     style={{
                       ...statusStyle,
                       backgroundColor: "#d9534f",
                       color: "#ffffff",
                     }}
                   >
                     Expiry Date: {Moment(cell.row.original.firmDemoExpiryDate).format("DD-MMM-YYYY").toLocaleLowerCase()}
                   </div>
                 </div>
               )}
                {cell.row.original.firmDemoStudyCount != null && cell.row.original.firmMaxStudyUploads != null && cell.row.original.firmMaxStudyUploads > 0 && (
                 <div className="study-list-reportDetails-badges">
                   <div
                     className="study-list-report-details-text"
                     style={{
                       ...statusStyle,
                       backgroundColor: "#d9534f",
                       color: "#ffffff",
                     }}
                   >
                      Studies Consumed: {cell.row.original.firmDemoStudyCount} / {cell.row.original.firmMaxStudyUploads}
                   </div>
                 </div>
               )}
             </div>
           )}
        </>
      ),
    },
    {
      id: "action",
      style: {
        width: actionW,
        display: "flex",
        height: "80px",
        alignItems: "center",
        boxSizing:'border-box'
      },
      headerClass: "break-word",
      classChildName: "break-word cursor-pointer",
      headerStyle: {
        padding: childTrPadding,
        textAlign: "left",
        width: actionW,
      },
      header: () => <span>{t("supervisor.action")}</span>,
      accessor: "action",
      accessorKey: "action",
      show: userRole != USERTYPES.FIRMDOCTOR && userRole != USERTYPES.FIRMTECHNICIAN ? true : false,
      cell: (cell) => (
        <>
          {/* <p style={{margin:'0px'}}>{!cell.row.original.active ? "Inactive" : "Active"}</p> */}
          {((userRole === USERTYPES.FIRMADMIN || userRole === USERTYPES.RADIOLOGIST) &&
            cell.row.original.status !== "Active") ||
          (userRole === USERTYPES.ADMIN &&
            cell.row.original.active === false) ? (
            <PrimaryButton
              text={t("hospital.activate")}
              //text={cell.row.values.action}
              onClick={(event) =>
                handleClickGroup(event, cell.row.original.id, cell)
              }
              style={{
                width: "80px",
                padding: "0",
              }}
            />
          ) : (
            <DefaultButton
              text={t("hospital.deactivate")}
              //text={cell.row.values.action}
              onClick={(event) =>
                handleClickGroup(event, cell.row.original.id, cell)
              }
              style={{
                width: "80px",
                padding: "0",
              }}
            />
          )}
        </>
      ),
    },
  ];
};
export default ColumnsClient;
